





















import Vue from "vue";
import { Trophy } from "@tt-app/models";

import ExerciseTrophy from "@tt-app/components/exercise/common/ExerciseTrophy.vue";
import PictureMatchMultipleChoice from "@tt-app/components/exercise/PictureMatchMultipleChoice.vue";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

interface Answer {
  correctId: boolean;
  isCorrect: boolean;
  selectedId: boolean;
}

interface Answers {
  [key: string]: Answer;
}

interface Review {
  body: any[];
  footer: any[];
}

interface ReviewElement {
  body?: any[];
  footer?: any[];
  header?: any[];
  type: string;
}

interface Data {
  answers: Answers;
}

interface Methods {
  answer: (element: ReviewElement) => Answer;
  component: (element: ReviewElement) => any;
  problemUuid: (element: ReviewElement) => string;
}

interface Computed {
  reviewElements: any;
}

interface Props {
  answers: Answers;
  audioDecoderPlayer: AudioDecoderPlayer;
  review: Review;
  totalQuestions: number;
  trophy: Trophy;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "PictureMatchReview",

  components: {
    ExerciseTrophy,
    PictureMatchMultipleChoice
  },

  props: {
    answers: {
      type: Object,
      required: true
    },

    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      default: undefined
    },

    review: {
      type: Object,
      required: true
    },

    totalQuestions: {
      type: Number,
      required: true
    },

    trophy: {
      type: Object,
      default: undefined
    }
  },

  computed: {
    reviewElements() {
      if (!this.review.body) {
        return [];
      }

      return this.review.body;
    }
  },

  methods: {
    answer(element) {
      return this.answers[this.problemUuid(element)];
    },

    component(componentConfig) {
      const components: { [key: string]: string } = {
        CARD: "picture-match-multiple-choice"
      };

      const { type } = componentConfig;

      return components[type];
    },

    problemUuid(element) {
      const problemElement = element.body?.find(innerElement => {
        return innerElement.type === "IMAGE_SINGLE_SELECTION";
      });

      return problemElement.problemUuid;
    }
  }
});
